import { ProductV2 } from '../models/product-v2.model';

const TELEMEDICINE_PRODUCT_NAMES = new Set(['starbem', 'telemedicina', 'telemedicine']);

const TELEMEDICINE_ALLOWED_PLAN_NAMES = new Set([
  'Pacote - Basic',
  'Pacote - Bronze',
  'Pacote - Silver',
  'Pacote - Bronze com Dependente',
  'Pacote - Silver com Dependente',
  'Pacote - Premium',
  'Package - Basic',
  'Package - Bronze',
  'Package - Silver',
  'Package - Bronze with Dependent',
  'Package - Silver with Dependent',
  'Package - Premium',
  'Paquete - Básico',
  'Paquete - Bronce',
  'Paquete - Plata',
  'Paquete - Bronce con Dependiente',
  'Paquete - Plata con Dependiente',
  'Paquete - Premium',
]);

export const TELEMEDICINE_ACCESS_LINK = 'https://empresas.starbem.app/';
export const TELEMEDICINE_DEFAULT_PASSWORD = '@Mudar123';

export function isTelemedicineProduct(productName?: string | null): boolean {
  if (!productName) {
    return false;
  }
  return TELEMEDICINE_PRODUCT_NAMES.has(productName.trim().toLowerCase());
}

/** Restringe variações de produtos de telemedicina aos pacotes permitidos. */
export function filterTelemedicineVariationPlans<T extends { name: string }>(
  plans: T[]
): T[] {
  return (plans ?? []).filter(plan => TELEMEDICINE_ALLOWED_PLAN_NAMES.has(plan.name));
}

/** Restringe variações de produtos de telemedicina aos pacotes permitidos. */
export function applyTelemedicineVariationFilter(product: ProductV2): void {
  if (!isTelemedicineProduct(product?.name)) {
    return;
  }
  product.variations = filterTelemedicineVariationPlans(product.variations || []);
}
